export default "__VITE_ASSET__BeXDH9it__"